import BrandLogo from '../components/BrandLogo'

const EXPECTATIONS = [
  'Make a real effort to use DIZEE in your day-to-day work.',
  'Invite your internal team to collaborate inside the platform.',
  'Participate in a 30-minute feedback session with DIZEE every other month.',
  'Suggest new workflows, features, and additions that would make the product more valuable.',
]

const COMPENSATION = [
  'Free use of the product and a direct hand in shaping the tools you actually want. We will build with this group, not around it.',
  'Optional equity participation through a SAFE: $25K minimum investment at a $10M valuation cap.',
]

export default function StrategicAdvisoryGroupPage() {
  return (
    <div className="white-page-root min-h-screen w-full bg-white text-zinc-950">
      <div className="mx-auto max-w-5xl px-6 py-8 sm:px-10 sm:py-10 lg:px-12 lg:py-12">
        <div className="flex items-center justify-between gap-4 border-b border-zinc-200 pb-6">
          <div className="flex items-center gap-3">
            <div className="h-5 w-5 rounded-sm bg-[#FF2300]" aria-hidden />
            <BrandLogo className="h-3.5 w-auto text-zinc-950" />
          </div>
          <p className="text-[11px] font-medium uppercase tracking-[0.24em] text-zinc-400">
            Strategic Group
          </p>
        </div>

        <main className="py-12 sm:py-16">
          <div className="max-w-3xl">
            <p className="text-sm font-medium uppercase tracking-[0.24em] text-[#FF2300]">
              Founding Circle
            </p>
            <h1 className="mt-4 text-4xl font-semibold tracking-tight text-zinc-950 sm:text-5xl">
              Strategic Advisory Group
            </h1>
            <p className="mt-6 text-lg leading-8 text-zinc-600 sm:text-xl">
              The future of the music business will not be built in isolation. It will be shaped
              by a small circle of experienced operators who understand where the industry is going
              and want to help define the system it deserves.
            </p>
          </div>

          <div className="mt-12">
            <section className="rounded-3xl border border-[#FF2300]/20 bg-[#FF2300]/[0.04] p-7 sm:p-8">
              <p className="text-sm font-semibold uppercase tracking-[0.2em] text-[#FF2300]">
                Shared Alignment
              </p>
              <p className="mt-5 text-2xl font-semibold tracking-tight text-zinc-950">
                Help shape the operating system modern music has been missing.
              </p>
              <p className="mt-4 text-base leading-7 text-zinc-600">
                This group is designed for 10-15 music industry veterans across artists,
                management, touring, agents, and promoters who want meaningful influence on the
                product, direct access to the team, and long-term alignment as DIZEE takes shape.
              </p>
            </section>
          </div>

          <div className="mt-8 grid gap-6 lg:grid-cols-2">
            <section className="rounded-3xl border border-zinc-200 p-7 sm:p-8">
              <h2 className="text-2xl font-semibold tracking-tight text-zinc-950">Expectations</h2>
              <div className="mt-6 space-y-4">
                {EXPECTATIONS.map((item) => (
                  <div key={item} className="flex gap-4">
                    <div className="mt-3 h-2 w-2 rounded-full bg-[#FF2300] shrink-0" aria-hidden />
                    <p className="text-base leading-7 text-zinc-700">{item}</p>
                  </div>
                ))}
              </div>
            </section>

            <section className="rounded-3xl border border-zinc-200 p-7 sm:p-8">
              <h2 className="text-2xl font-semibold tracking-tight text-zinc-950">Compensation</h2>
              <div className="mt-6 space-y-6">
                {COMPENSATION.map((item) => (
                  <div key={item} className="rounded-2xl bg-zinc-50 px-5 py-5">
                    <p className="text-base leading-7 text-zinc-700">{item}</p>
                  </div>
                ))}
              </div>
            </section>
          </div>

          <section className="mt-8 rounded-3xl border border-zinc-200 p-7 sm:p-8">
            <p className="text-sm font-semibold uppercase tracking-[0.2em] text-zinc-500">
              Why This Group Matters
            </p>
            <p className="mt-4 max-w-3xl text-lg leading-8 text-zinc-950">
              We want this first group to be deeply practical: people who are active in the music
              business, willing to use DIZEE in real workflows, and excited to help shape a system
              that genuinely serves artists and their teams.
            </p>
          </section>
        </main>
      </div>
    </div>
  )
}
